'use client';

import { useState } from "react";
import LoginContainer from "../auth/login_container";
import classes from "./login_modal_login.module.css";

export default function LoginModalLogin({}) {
    const [success, setSucces] = useState(false);

    return <>
        <LoginContainer success={success} setSucces={setSucces} is_modal />
    </>
}